import { Col, Form, Row } from 'antd'
import { Select } from 'components/atoms'
import { STATUS_ACTIVE_OPTIONS } from 'constants/options'
import { EStatus } from 'enums'
import { useProfile } from 'hooks'
import { t } from 'i18next'
import { ISearchQuery } from 'interfaces'
import styled from 'styled-components'

const StyledRow = styled(Row)`
  flex: 1;
`
const StyledForm = styled(Form)`
  width: 100%;
`
interface IProps {
  onClick?: () => void
  children?: React.ReactNode
  onSearch?: (value: any) => void
  payloadSearch?: ISearchQuery<any>
}

const RoleFilter = (props: IProps) => {
  const { onSearch } = props
  const [form] = Form.useForm()
  const { userId: clinicId } = useProfile()
  const onFilterStatusClinicRole = (status?: number) => {
    if (onSearch) {
      onSearch({
        status,
        clinic_id: clinicId
      })
    }
  }
  return (
    <StyledForm form={form} initialValues={{ status: EStatus.Active }}>
      <StyledRow gutter={16}>
        <Col span={5}>
          <Form.Item name="statuses">
            <Select
              showArrow
              allowClear
              title={t('status')}
              onChange={onFilterStatusClinicRole}
              placeholder={t('please-choose-info')}
              options={STATUS_ACTIVE_OPTIONS}
              filterOption={false}
            />
          </Form.Item>
        </Col>
      </StyledRow>
    </StyledForm>
  )
}

export default RoleFilter
